import type { ButtonProps } from '@chakra-ui/react'
import { Badge, Box } from '@chakra-ui/react'
import type { HTMLAttributeAnchorTarget } from 'react'
import React from 'react'

import { useApp } from '@/hooks/useApp'

import { useSettingsMenu } from '@/hooks/useSettingsMenu'
import { useLogout } from 'BrokerTsLib/src/hooks/useAccount'
import { useAuth } from '../../context/AuthContext'
import { Contract, Logout, News, Offer, Settings, User } from '../../icons'
import { MenuGroup } from './MenuGroup'
import { MenuItem } from './MenuItem'
import { MenuItemWithSubMenu } from './MenuItemWithSubMenu'
import { NewInsuranceButton } from './NewInsuranceButton'
import { SubMenu } from './SubMenu'

export interface MenuGroupProps {
  children: React.ReactNode
}

export interface MenuItemProps extends ButtonProps {
  children: React.ReactNode
  href?: string
  to?: string
  variant?: string
  colorScheme?: string
  target?: HTMLAttributeAnchorTarget
}

export interface SubMenuProps {
  button: React.ReactElement
  subMenu: React.ReactNode
  trigger?: 'mouse' | 'click'
}

export const Menu = () => {
  const { app } = useApp()
  const menuApp = app === 'carkulka-extra' ? 'carkulka' : app!

  const { user, carkulkaUnreadMessages, chaloupkaUnreadMessages, cestovkoUnreadMessages } = useAuth() ?? {}

  const newsCount = menuApp === 'carkulka' ? carkulkaUnreadMessages
    : menuApp === 'chaloupka' ? chaloupkaUnreadMessages
      : menuApp === 'cestovko' ? cestovkoUnreadMessages
        : 0


  const { showSettings, settingsItems } = useSettingsMenu()
  
  const { logout, isLoggingOut } = useLogout()

  return (
    <Box
      sx={{
        display: { base: 'none', xl: 'grid' },
        width: '100%',
        gridAutoFlow: 'column',
        justifyContent: 'space-between',
        justifyItems: 'space-between',
      }}
      className="site-menu-wrapper"
    >
      <MenuGroup>
        <li>
          <NewInsuranceButton app={menuApp} />
        </li>
        <li>
          <MenuItem to={`/${menuApp}/concepts`}>
            <Offer color="secondary.500" />
            Nabídky
          </MenuItem>
        </li>
        <li>
          <MenuItem to={`/${menuApp}/contracts`}>
            <Contract color="secondary.500" />
            Smlouvy
          </MenuItem>
        </li>

        {showSettings && (
            <li>
              <MenuItemWithSubMenu
                button={
                  <MenuItem as={Box} cursor='pointer'>
                    <Settings color="secondary.500" />
                    Nastavení
                  </MenuItem>
                }
                subMenu={
                  <SubMenu>
                    {user &&
                      settingsItems!.map((item) => {
                        return (
                          <li key={item.to}>
                            <MenuItem href={item.to}>{item.label}</MenuItem>
                          </li>
                        )
                      })}
                  </SubMenu>
                }
              />
            </li>
          )}
      </MenuGroup>

      <MenuGroup>
        <li>
          <MenuItem to={`/${menuApp}/news`}>
            <News color="secondary.500" />
            Aktuality
            <Badge>{newsCount}</Badge>
          </MenuItem>
        </li>
        <li>
          <MenuItem
            {...(user?.vehicleRights
              ? {
                to: '/profile',
              }
              : {
                as: 'div',
                isDisabled: true,
              })}
          >
            <User color="secondary.500" />
            {user?.userFullName}
          </MenuItem>
        </li>
        <li>
          <MenuItem as={'button'} onClick={() => logout()} isLoading={isLoggingOut}>
            <Logout color="secondary.500" />
          </MenuItem>
        </li>
      </MenuGroup>
    </Box>
  )
}
